import $ from 'jquery';
import RichMenu from '../libs/RichMenu';

export default {
    data() {
        return {
            url: null,
            titleFacebook: window.GrandsEspaces.site_name,
            descriptionFacebook: null,
            titleTwitter: window.GrandsEspaces.site_name,
            descriptionTwitter: null,
            siteName: null,

            mobileModalShow: false
        };
    },
    methods: {

        getOpenGraphData(property) {
            return document.querySelector(`meta[property="${property}"]`) ? document.querySelector(`meta[property="${property}"]`).getAttribute('content') : null;
        },
        getTwitterData(property) {
            return document.querySelector(`meta[name="${property}"]`) ? document.querySelector(`meta[name="${property}"]`).getAttribute('content') : null;
        },
        updateInfos() {

            let backupDescription = $('body').hasClass('single-travelogue') ? $('.sous-titre-page p').html() : $('.story-line .content-text p').html();

            this.url = this.getOpenGraphData('og:url') ? this.getOpenGraphData('og:url') : document.location.href;

            this.titleFacebook = this.getOpenGraphData('og:title') ? this.getOpenGraphData('og:title') : window.GrandsEspaces.site_name;
            this.descriptionFacebook = this.getOpenGraphData('og:description') ? this.getOpenGraphData('og:description') : backupDescription;

            this.titleTwitter = this.getTwitterData('twitter:title') ? this.getTwitterData('twitter:title') : window.GrandsEspaces.site_name;
            this.descriptionTwitter = this.getTwitterData('twitter:description') ? this.getTwitterData('twitter:description') : backupDescription;

            this.siteName = this.getOpenGraphData('og:site_name') ? this.getOpenGraphData('og:site_name') : window.GrandsEspaces.site_name;
        },
        newTab(name, urlservice) {

            var width = 575,
                height = 400,
                left = ($(window).width() - width) / 2,
                top = ($(window).height() - height) / 2,
                url = urlservice,
                opts = 'status=1' +
                    ',width=' + width +
                    ',height=' + height +
                    ',top=' + top +
                    ',left=' + left;

            window.open(url, name, opts);


            return false;

        },
        mobileShareCta() {

            this.updateInfos();
            // Check if Mobile for Native Share

            if (navigator.share) {
                this.shareMobileChrome();
                return null;
            }

            this.openMobileSharePanel();

            $('#bg-overlay').on('click', () => {
                this.closeMobileSharePanel();
            });
        },
        openMobileSharePanel() {
            this.mobileModalShow = !this.mobileModalShow;
            RichMenu.showBgOverlay('modal', 300, 0.6);
            $('html').addClass('no-scroll');
        },
        closeMobileSharePanel() {
            RichMenu.hideBgOverlay('modal');
            this.mobileModalShow = false;
            $('html').removeClass('no-scroll');
        },
        shareMobileChrome() {
            navigator.share({
                title: this.titleFacebook,
                text: this.descriptionFacebook,
                url: this.url,
            })
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing', error));
        },
        desktopFacebook() {
            this.updateInfos();

            FB.ui({
                method: 'share',
                href: this.url,
            }, function (response) {
            });

        },
        mobileFacebook() {
            this.updateInfos();
            FB.ui({
                method: 'share',
                href: this.url,
                mobile_iframe: true,
            }, (response) => {
                this.closeMobileSharePanel();
            });
        },
        desktopTwitter(mobile) {
            this.updateInfos();
            let twitterLink = `https://twitter.com/share?text=${encodeURIComponent(this.descriptionTwitter)}&url=${encodeURIComponent(this.url)}`;

            this.newTab('twitter', twitterLink);
            if (mobile) {
                this.closeMobileSharePanel();
            }
        },
        shareMail(mobile) {
            this.updateInfos();

            let desc = this.descriptionFacebook.substring(0, 300) + ' ...';

            let url = `<a href="${this.url}">${this.url}</a>`;

            window.location.href = `mailto:email@destinataire?subject=[ ${encodeURIComponent(this.siteName)} ] - ${encodeURIComponent(this.titleFacebook)}&body=${encodeURIComponent(url)}<br><br>${encodeURIComponent(desc)}`;
            if (mobile) {
                this.closeMobileSharePanel();
            }
        }
    },
};


// WEBPACK FOOTER //
// ./assets/js/mixins/shareFunctions.js